<template>
    <div class="page">
        <tabs :tabs="tabs" />
    </div>
</template>

<script>
import { mapState } from 'vuex';
import routeNames from '@enums/route-names';
import guardsMap from './supplier-guards-map';

export default {
    beforeRouteUpdate(to, from) {
        if (to.name === from.name) {
            // navigating to the same route only params has changed
            // manualy fire beforeEntered hook because it is not called automatically
            guardsMap[to.name](to, from);
        } else {
            return true;
        }
    },
    computed: {
        ...mapState('clientConfig', ['toggleLogic']),
        tabs() {
            const tabs = [
                {
                    label: this.toSentenceCase(this.$t('supplierTabs.supplierCommitments')),
                    disabled: false,
                    component: 'supplier-commitments-viewer',
                    path: 'commitments',
                    routeNames: [
                        routeNames.supplierCommitmentsView,
                        routeNames.supplierCommitmentView,
                    ],
                },
                {
                    label: this.toSentenceCase(this.$t('supplierTabs.variableFunding')),
                    disabled: false,
                    component: 'variable-funding',
                    path: 'variable-funding',
                    routeNames: [routeNames.variableFundingView],
                },
            ];

            return tabs;
        },
    },
};
</script>

<style scoped lang="scss">
.page {
    height: 100%;
    margin-top: 2rem;
    padding: 0 1rem;
}
</style>
